import React, { Fragment, useEffect, useState } from "react";
import ComparisonItem from "features/Companies/Customers/Change Requests/ComparisonItem";

const ComparisonBox = ({ header, isCrm, ...props }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.customerName) {
      setLoading(false);
    }
  }, [props]);

  const FieldComparisonItem = ({ label, field }) => (
    <ComparisonItem
      label={label}
      value={isCrm ? props[field]?.crmValue : props[field]?.opalValue}
      isMatch={isCrm ? props[field]?.isMatch : null}
      isCrm={isCrm}
    />
  );

  const addressFields = [
    "addressLine1",
    "addressLine2",
    "addressTown",
    "addressCountry",
    "addressCounty",
    "addressPostcode",
  ];

  return (
    <div
      style={{
        borderRadius: 6,
        border: "10px solid #F9F9F9",
        height: "100%",
        width: "49%",
        paddingBottom: "20px",
        paddingLeft: "20px",
      }}
    >
      <p style={{ color: "#6B036B", fontSize: 22, fontWeight: 600 }}>
        {header}
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {loading ? (
          <Fragment />
        ) : (
          <Fragment>
            <FieldComparisonItem label="Customer Name" field="customerName" />

            <FieldComparisonItem label="Trading As" field="tradingAs" />

            <ComparisonItem
              label="Trading Address"
              minHeight={100}
              value={addressFields.map(
                (f) => props[f][isCrm ? "crmValue" : "opalValue"],
              )}
              isMatch={isCrm ? addressFields.map((f) => props[f].isMatch) : []}
              isCrm={isCrm}
            />

            <FieldComparisonItem
              label="Company Reg Number"
              field="companyRegNo"
            />

            <FieldComparisonItem
              label="Supplier Office"
              field="supplierOffice"
            />

            <FieldComparisonItem label="Company ID" field="companyId" />
          </Fragment>
        )}
      </div>
    </div>
  );
};
export default ComparisonBox;
